import store from "src/Reducers/store";
import * as appActions from "src/Actions/appActions";

const setPreviousPage = (pageIndex: number) => store.dispatch(appActions.setPreviousPage(pageIndex));

export default setPreviousPage;
